export default __webpack_public_path__ + "static/media/United Technologies.644ed4c0.jpg";